<template>
  <b-table-simple bordered
                  id="survey-tendency-comparison-by-employee-journey-table">
    <b-thead head-variant="light">
      <tr>
        <template v-for="col in cols">
          <b-th :key="col">{{ col }}</b-th>
        </template>
      </tr>
    </b-thead>
    <b-tbody>
      <template v-for="(row, i) in items">
        <b-tr :key="`row${i}`">
          <template v-for="(col, j) in cols">
            <template v-if="col === '구분'">
              <b-td :key="`cell${i}${j}`"
                    :style="{ 'background-color': getColor(row[col]) }"> {{ row[col] }}
              </b-td>
            </template>
            <template v-else>
              <b-td :key="`cell${i}${j}`">{{ row[col] }}</b-td>
            </template>
          </template>
        </b-tr>
      </template>
    </b-tbody>
  </b-table-simple>
</template>

<script>
export default {
  props: {
    slide: Object,
    items: Array,
    graphType: String
  },
  computed: {
    cols() {
      return Object.keys(this.items[0]);
    },
    showTable() {
      return this.items.length > 0;
    },
  },
  methods: {
    convertToPercentage(number) {
      const percentage = number.toFixed(2);
      if (percentage === '0.00') {
        return '';
      }
      return `(${percentage}%)`;
    },
    getColor(type) {
      let colors = {
        "긍정": '#8faadc',
        "부정": '#ffbf00',
        "중립": '#d6d8db',
      };
      return colors[type];
    }
  }
};
</script>

<style>
#survey-tendency-comparison-by-employee-journey-table {
    height: 400px;
    font-size: 13pt;
    margin-bottom: 0;
    margin-top: 10px;
}

#survey-tendency-comparison-by-employee-journey-table td,
#survey-tendency-comparison-by-employee-journey-table th {
    text-align: center;
    vertical-align: middle;
}
</style>
